
import { baseClasses } from '@weatherbug/common';
import type { GetNewsStoriesByDateParams, GetNewsStoriesByDateResult, GetNewsStoriesByDateSyncerParams, GetNewsStoriesSyncerParams, GetStoriesParams, GetStoriesResult } from './types';

const storiesUri = '/api/media/stories';
const storiesByDateUri = '/api/media/storiesbyDate';
const getWebStoriesKey = 'getwebstories';
const getWebStoriesByDateKey = 'getwebstoriesbydate';

// Cache for 1 hour
const cacheDurationMilliseconds = 60 * 60 * 1000;

const { PulseBaseProvider } = baseClasses;

const getStoriesValidationFunction = (result: GetStoriesResult) => {
    return result?.length > 0;
};

export class StoriesProvider extends PulseBaseProvider {
    constructor(baseUrl: string, authId?: string, secret?:string, options?: any, logger?: any) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[getWebStoriesKey] = this.getNewsStoriesSyncer.bind(this);
        this.storage.sync[getWebStoriesByDateKey] = this.getNewsStoriesByDateSyncer.bind(this);
    }

    async getNewsStoriesSyncer(params: GetNewsStoriesSyncerParams): Promise<GetStoriesResult>  {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
            category: parsedQParams.category,
            tags: parsedQParams.tags,
            content: parsedQParams.content,
            count: parsedQParams.count
        };
        return await super.syncData(key, id, queryParams, storiesUri, resolve, reject, getStoriesValidationFunction, pulseApi, undefined, undefined, false, cacheDurationMilliseconds);
    }

    async getNewsStoriesByDateSyncer(params: GetNewsStoriesByDateSyncerParams): Promise<GetStoriesResult> {
        const { id, syncParams, resolve, reject } = params;
        const { key, startTime, endTime, order, count, featured, index, isVideoPage, pulseApi } = syncParams;

        const queryParams = {
            startTime,
            endTime,
            featured,
            index,
            count,
            order,
            isVideoPage
        };

        return await super.syncData(key, id, queryParams, storiesByDateUri, resolve, reject, getStoriesValidationFunction, pulseApi, undefined, undefined, false, cacheDurationMilliseconds);
    }

    async getNewsStories({
        category,
        tags,
        content,
        count }: GetStoriesParams): Promise<GetStoriesResult> {
        const syncParams = {
            category: category,
            tags: tags,
            content: content,
            count: count
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getWebStoriesKey, id, syncParams);
    }

    async getNewsStoriesByDate({ startTime, endTime, order, count, featured, index, isVideoPage = false }: GetNewsStoriesByDateParams): Promise<GetNewsStoriesByDateResult> {
        const syncParams = {
            startTime,
            endTime,
            order,
            count,
            featured,
            index,
            isVideoPage
        };

        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getWebStoriesByDateKey, id, syncParams);
    }
}
